<template>
  <div class="about">
    <div class="col history" v-html="options.about_desc"></div>
    <div class="col content" v-html="options.about_content"></div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'about',
    computed: {
      ...mapState(['options'])
    }
  }
</script>

<style lang="stylus" scoped>
  .about
    padding 0 100px
    display flex
    justify-content space-between

    >>> p
      line-height 1.5
      .ql-size-small
        font-size 1.6rem

    .col
      font-size 2rem
      font-family 'NeutraTextTF-Bold'
      flex-basis calc((100% - 30px) / 2)

      &.content
        font-size 1.6rem
        font-family 'NeutraText-Book'
        >>> img
          max-width 60%

  @media screen and (max-width: 768px)
    .about
      padding 0 20px
      flex-wrap wrap

      .col
        margin-bottom 30px
        flex-basis 100%

        img
          max-width 100%
</style>
